import { createContext, useContext } from 'react';

export type ApolloErrorKind = 'graphql' | 'network' | 'unknown';

export type ApolloErrorState = {
  kind: ApolloErrorKind;
  operationName: string;
  message: string;
  details?: string[];
};

export type ApolloErrorContextValue = {
  error: ApolloErrorState | null;
  clearError: () => void;
};

export const ApolloErrorContext = createContext<ApolloErrorContextValue | undefined>(undefined);

export const useApolloError = (): ApolloErrorContextValue => {
  const context = useContext(ApolloErrorContext);
  if (!context) {
    throw new Error('useApolloError must be used within ApolloContextProvider.');
  }
  return context;
};
